import { request } from '@umijs/max';

const userService = {
  getUserDetails: async (options?: { [key: string]: any }) => {
    const response = await request<API.Service.UserDetail>(`/player/details`, {
      method: 'GET',
      ...(options || {}),
    });

    return response;
  },

  syncUser: async (options?: { [key: string]: any }) => {
    const response = await request(`/player/sync`, {
      method: 'GET',
      ...(options || {}),
    });
    return response;
  },
};

export default userService;
